import api from '../lib/api'

export const runBotSandbox = (tenantId, payload) =>
  api.post(`/admin/tenants/${encodeURIComponent(tenantId)}/bot-sandbox/chat`, payload).then((response) => response.data)
